export const WorkflowBDC = {
    BdcToChefsVentes: "BdcToChefsVentes",
    BdcToVendeurs: "BdcToVendeurs",
    BdcToChefsVentesVendeurs: "BdcToChefsVentesVendeurs",
    BdcToPotCommunVendeurs: "BdcToPotCommunVendeurs",
    BdcToChefsVentesVendeursPotCommunVendeurs: "BdcToChefsVentesVendeursPotCommunVendeurs",
}